const OTP_CODE_ALREADY_EXISTS = 'OTP_CODE_ALREADY_EXISTS';

export {
  OTP_CODE_ALREADY_EXISTS
};
